export default {
  default: () => import("/home/forge/stage.efxpp.ch/layouts/default.vue").then(m => m.default || m)
}